import {
  getQuizResults,
  getQuizResult,
  createQuizResult,
  updateQuizResult,
  deleteQuizResult,
} from 'utils/queries/quiz';

export const quizEndpoints = (build) => ({
  getQuizResults: build.query({
    query: (args) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getQuizResults,
        variables: args,
      }),
    }),
    transformResponse: (response) => response.data.getQuizResults,
  }),
  getQuizResult: build.query({
    query: (id) => ({
      method: 'POST',
      body: JSON.stringify({
        query: getQuizResult,
        variables: { id },
      }),
    }),
    transformResponse: (response) => response.data.getQuizResult,
  }),
  createQuizResult: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: createQuizResult,
        variables: input,
      }),
    }),
    transformResponse: (response) => response.data.createQuizResult,
  }),
  updateQuizResult: build.mutation({
    query: (input) => ({
      method: 'POST',
      body: JSON.stringify({
        query: updateQuizResult,
        variables: input,
      }),
    }),
    transformResponse: (response) => response.data.updateQuizResult,
  }),
  deleteQuizResult: build.mutation({
    query: (id) => ({
      method: 'POST',
      body: JSON.stringify({
        query: deleteQuizResult,
        variables: { id },
      }),
    }),
    transformResponse: (response) => response.data.deleteQuizResult,
  }),
});
